import { LineItemType, BundleLineItemType } from '../../../__generated__/sharedTypes.js';

const mapContactLensesBundleBeneluxLineItem = ({ sku , quantity , typeDetails  })=>{
    const { leftLensBaseCurve , leftLensDiameter , leftLensPower , leftLensAxis , leftLensCylinder  } = typeDetails;
    const { rightLensBaseCurve , rightLensDiameter , rightLensPower , rightLensAxis , rightLensCylinder ,  } = typeDetails;
    return {
        sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: LineItemType.BUNDLE,
        bundleLineItemsType: BundleLineItemType.CONTACT_LENSES_BENELUX,
        typeDetails: {
            prescription: {
                rightLens: {
                    baseCurve: rightLensBaseCurve,
                    diameter: rightLensDiameter,
                    power: rightLensPower,
                    axis: rightLensAxis,
                    cylinder: rightLensCylinder
                },
                leftLens: {
                    baseCurve: leftLensBaseCurve,
                    diameter: leftLensDiameter,
                    power: leftLensPower,
                    axis: leftLensAxis,
                    cylinder: leftLensCylinder
                }
            }
        }
    };
};

export { mapContactLensesBundleBeneluxLineItem };
//# sourceMappingURL=contact-lenses-bundle-benelux.js.map
